import { formattedInsiderTrackObject } from '../../utils'

export function insiderObjectModel({ details = {} } = {}) {
  const {
    id = '',
    make = '',
    model = '',
    version = '',
    bodyType = '',
    color = '',
    fuel = '',
    transmission = '',
    kilometer = '',
    condition = '',
    exchangeable = '',
    IPVA = '',
    year = '',
    finalPlate = '',
    price = '',
    vehicleType = '',
    city = '',
    vehiclePhoto = '',
  } = formattedInsiderTrackObject({ details })

  return {
    page: {
      type: 'Product',
    },
    product: {
      currency: 'BRL',
      id,
      name: make ? `${make} ${model}` : '',
      product_image_url: vehiclePhoto,
      unit_price: price,
      unit_sale_price: price,
      url: window.location.href,
      taxonomy: [
        bodyType,
        make,
        model,
        color,
        fuel,
        version,
        transmission,
        vehicleType,
      ],
      custom: {
        kilometer,
        condition,
        exchangeable,
        final_plate: finalPlate,
        ipva: IPVA,
        year,
        city,
        flow_type: 'Comprar',
        color,
      },
    },
  }
}
